<div
  class="container"
  #container
  (keydown.ArrowRight)="increaseId($event)"
  (keydown.ArrowLeft)="decreaseId($event)"
>
  <div class="button-grid">
    <div></div>
    <div>
      <button (click)="decreaseId($event)">PREV</button><span>/</span>
      <button (click)="increaseId($event)">NEXT</button>
    </div>
    <mat-icon
      (click)="goBack()"
      routerLink="../display"
      svgIcon="grid"
      aria-hidden="false"
      aria-label="Grid SVG icon"
    ></mat-icon>
  </div>
  <div class="arrow-l" (click)="decreaseId($event)"></div>
  <img
    #photo
    (click)="goBack()"
    routerLink="../display"
    data-src="{{ publicId }}"
    class="hidden"
    (load)="easeIn()"
    autofocus
  />
  <div class="arrow-r" (click)="increaseId($event)"></div>
</div>
